import IconExpand from 'approot/shared/icons/icon-expand';
import { SecondaryButtonAndIconLink } from 'approot/shared/styles/buttons/secondary-button.style';
import { spacing8 } from 'approot/shared/styles/spacing.style';
import {
  TeachingLearningSequencePillWrapper,
  TeachingLearningSequenceViewTitle,
} from './teaching-learning-sequence.style';

const TeachingLearningMetaData = ({
  title,
  items,
}: {
  title: string;
  items:
    | {
        id: string;
        name: string;
        link: string;
      }[]
    | null;
}) => {
  return (
    <>
      <TeachingLearningSequenceViewTitle>
        {title}
      </TeachingLearningSequenceViewTitle>
      <TeachingLearningSequencePillWrapper $gap={spacing8} $marginBottom={24}>
        {items?.map(item => (
          <SecondaryButtonAndIconLink
            key={item.id}
            to={item.link}
            $isSmall
            target="_blank"
            aria-label={`${title}: ${item.name}. Read more in a new tab.`}
          >
            {item.name}
            <IconExpand width={20} height={20} />
          </SecondaryButtonAndIconLink>
        ))}
      </TeachingLearningSequencePillWrapper>
    </>
  );
};

export default TeachingLearningMetaData;
